import { MobileNotSupportedComponent } from "../mobile-not-supported/mobile-not-supported.component";
import { Component, OnInit, ViewChild, ElementRef, ChangeDetectorRef } from "@angular/core";
import {
  FormControl,
  FormGroup,
  Validators,
  ReactiveFormsModule,
  FormsModule,
} from "@angular/forms";
import { Router, ActivatedRoute, RouterLink } from "@angular/router";
import { MediaService } from "src/app/service/media.service";
import JSZip from "jszip";
import { OnlineUsersService } from "src/app/service/online-users.service";
import { saveAs } from "file-saver";

import {
  alertModal,
  alertModalWithoutConfirm,
  alertModalDelete,
} from "src/app/component/helpers/alert";

import { HttpEventType } from "@angular/common/http";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { UserService } from "src/app/service/user.service";
import {
  SlickCarouselComponent,
  SlickCarouselModule,
} from "ngx-slick-carousel";
import { HttpClient } from "@angular/common/http";
import { Observable, Subscription } from "rxjs";
import { Store } from "@ngrx/store";
import { uploadAction } from "src/app/store/counter.actions";
import { NgClass, NgStyle } from "@angular/common";
import { ChatService } from "src/app/service/chat.service";
import axios from "axios";
declare var MediaRecorder: any;
declare let Swiper: any;


const CHUNK_SIZE = 10 * 1024 * 1024;
const MIN_CHUNK_SIZE = 10 * 1024 * 1024;

@Component({
    selector: "app-upload",
    templateUrl: "./upload.component.html",
    styleUrls: ["./upload.component.css"],
    imports: [
        MobileNotSupportedComponent,
        NgClass,
        RouterLink,
        SlickCarouselModule,
        ReactiveFormsModule,
        NgStyle,
        FormsModule,
    ]
})
export class UploadComponent implements OnInit {

  constructor(
    private cdRef: ChangeDetectorRef,
    private mediaService: MediaService,
    private router: Router,
    private sanitizer: DomSanitizer,
    private route: ActivatedRoute,
    private UserService: UserService,
    private globalSocketService: OnlineUsersService,
    private http: HttpClient,
    private chatService: ChatService,
    private store: Store<{ uploadInfo }>
  ) {
    this.route.url.subscribe((segments) => {
      this.currentRoute = segments.join("/").split("/")[0];
      this.editId = segments.join("/").split("/")[1];
    });
    console.log(this.currentRoute);
    if (this.currentRoute == "edit") {
      this.edit = true;

      this.editData();
    }
  }
  @ViewChild("staticBackdrop") myModal: ElementRef;
  @ViewChild("slickModal") slickModal: SlickCarouselComponent | undefined;
  @ViewChild("previewvideo", { static: false }) previewVideo: any;
  // @ViewChild('preview-pdf') previewPdf: any;
  // @ViewChild('pdf') pdf: ElementRef<HTMLObjectElement>;
  @ViewChild("pdf", { static: false }) pdf: ElementRef;
  @ViewChild("uploadfile") uploadFile: any;
  @ViewChild("uploadname") uploadName: any;
  @ViewChild("previmg") prevImg: any;
  @ViewChild("excel-preview") excelPreview: any;
  @ViewChild("excel") excel: any;
  // @ViewChild('myLoader') myLoader: any;
  @ViewChild("loadingBar", { static: false }) loadingBar: any;
  @ViewChild("prog") prog: any;
  @ViewChild("progressBar") progressBar: any;
  @ViewChild("previewImage") previewImage: any;
  @ViewChild("cameraButton") cameraButton: any;
  @ViewChild("screenCaptureButton") screenCaptureButton: any;
  uploadInProgress: boolean = false;

  currentRoute: string;
  blogFiles: any;
  ResponseData: any;
  messageError: any;
  showThumbnail = false;
  mediaId: string;
  id: any;
  previewVideoUrl!: SafeResourceUrl;
  pdfUrl: SafeResourceUrl = this.sanitizer.bypassSecurityTrustResourceUrl("");
  selectedCollectionType: string = "Public";
  selectedProjectType: string = "Company";
  selectedAgreementType: string = "NDA";
  data: string = "";
  filesUrl: string[] = [];
  playList = [];
  dragAndDrop: any;
  slideConfig = {
    slidesToShow: 1,
    slidesToScroll: 1,
    swipeToSlide: true,
    infinite: false,
    centerMode: true,
  };
  customTags = [];
  ImagefilesResponseUrl = [];
  loaderUpload: boolean = false;
  newCollection = true;
  firstUpload = true;
  blobImage: any = "";
  edit: boolean = false;
  //upload progrss variable
  progress: number = 0;
  selectedFile: File; //Normal-upload
  archiveInProgress: boolean = false;
  message: string;
  count$: Observable<number>;
  private countSubscription: Subscription | undefined;

  blobFile: any;
  editId: any;
  mainFileUrl: string = "";
  startPhoto: boolean = false;
  menuOpened = false;
  typeVideoTag = false;
  collectionTypeTag = "public";
  companyNameTag = "square pixel";
  companyRelatedTags = [];
  collectionTags: string = "";
  collectionType: string = "Public";
  isCompanyProjectTag = "company";
  // ndaTag = "NDA";
  ndaTag = "NDA";
  existcollecttion = true;
  primaryTags = [
    this.collectionTypeTag,
    this.companyNameTag,
    this.isCompanyProjectTag,
    this.ndaTag,
  ];

  companyTagsArray = [
    {
      company: "Square pixel",
      companyTags: ["presentation", "excel", "image", "video", "pdf"],
    },
    {
      company: "Ink in caps",
      companyTags: [
        "presentation",
        "excel",
        "image",
        "video",
        "pdf",
        "word/docs",
      ],
    },
    { company: "Codepie", companyTags: ["js", "git", "html", "angular"] },
  ];

  saveUploadInfoToStore(body) {
    console.log({ sotreBody: body });
    this.store.dispatch(uploadAction({ body: body }));
  }
  @ViewChild("swiperContainer", { static: false }) swiperContainer: any;
  ngOnInit(): void {
    // this.getAllPlaylist(); //GET ALL PLAYLIST
    this.getInvitation();
    this.addToExistingCollection();
    this.connectionSocket();
  }

  thumbnailData: any;
  videoSTyle: any;
  connectionSocket() {
    this.chatService.listen("ARCHIVE").subscribe((res) => {
      console.log(res, "Archive socket response");
      if (res?.operation && res?.data?._id === this.id) {
        let data = res.data;
        let extension = res.data.extension;
        this.thumbnailData = data.thumbnails;
        this.filesUrl = data.thumbnails;
        this.thumbnailSpinner = false;
        this.archiveInProgress = false;
        this.editId = res["data"]["_id"];
        this.id = res["data"]["_id"];
        document.getElementById("ImageId").innerHTML = this.id;

        if (res["data"]["highQuality"]) {
          let video: HTMLVideoElement = this.previewVideo?.nativeElement;
          this.editId = data["_id"];
          this.id = res["data"]._id;
          document.getElementById("ImageId").innerHTML = this.id;
          // console.log(res["data"]["highQuality"]);
          // if (res?.data?.highQuality) {
          //   video.src = res["data"]["highQuality"];
          // } else {
          //   console.error("High quality URL is not defined or empty");
          // }
          // video.setAttribute("src", res["data"]["highQuality"]);
          video.src = res["data"]["highQuality"];
          video.style.display = "block";
          video.style.objectFit = "contain";
        }

        if (
          extension === ".pdf" ||
          extension === ".js" ||
          extension === ".html" ||
          extension === ".git" ||
          extension === ".angular"
        ) {
          const pdf: HTMLObjectElement = this.pdf.nativeElement;
          let pdfFileUrl = this.uploadFile?.nativeElement;
          let filename = this.uploadName?.nativeElement;

          filename.innerHTML = this.SocketFileName;
          pdfFileUrl.innerHTML = "file uploaded successfully";
          let img = this.prevImg.nativeElement;

          if (extension == ".pdf") {
            img.setAttribute("src", "../../../assets/Archive_files/pdf.png");
          }
          if (extension == ".js") {
            img.setAttribute("src", "../../../assets/js.png");
          }
          if (extension == ".html") {
            img.setAttribute("src", "../../../assets/html.png");
          }
          if (extension == ".git") {
            img.setAttribute("src", "../../../assets/git.png");
          }
          if (extension == ".angular") {
            img.setAttribute("src", "../../../assets/angular.png");
          }
          if (extension == ".doc" || extension == ".docx") {
            img.setAttribute("src", "../../../assets/docx-img.png");
          }
          this.pdfDis = this.pdfDis == "inline" ? "inline" : "none";
        }
        if (extension === ".xlsx" || extension === ".xls") {
          // var excel = this.excelPreview.nativeElement;
          let pdfFileUrl = this.uploadFile.nativeElement;
          let filename = this.uploadName.nativeElement;

          // filename.innerHTML = this.SocketFileName;
          console.log(this.SocketFileName);
          pdfFileUrl.innerHTML = "file uploaded successfully";
          let img = this.prevImg.nativeElement;
          img.setAttribute("src", "../../../assets/excl-img.jpg");
          this.pdfDis = this.pdfDis == "inline" ? "inline" : "none";
          const myLoaderElement: HTMLElement = this.loadingBar.nativeElement;
          myLoaderElement.classList.add("hide");
        }
        if (extension === ".docx" || extension === ".doc") {
          // var excel = this.excelPreview.nativeElement;
          let pdfFileUrl = this.uploadFile.nativeElement;
          let filename = this.uploadName.nativeElement;

          // filename.innerHTML = this.SocketFileName;
          console.log(this.SocketFileName);
          pdfFileUrl.innerHTML = "file uploaded successfully";
          let img = this.prevImg.nativeElement;
          img.setAttribute("src", "../../../assets/docx-img.png");
          this.pdfDis = this.pdfDis == "inline" ? "inline" : "none";
          const myLoaderElement: HTMLElement = this.loadingBar.nativeElement;
          myLoaderElement.classList.add("hide");
        } else if (extension === ".pptx") {
          const excelElement: HTMLInputElement | null =
            this.excel.nativeElement;
          let pdfFileUrl = this.uploadFile.nativeElement;
          let filename = this.uploadName.nativeElement;

          filename.innerHTML = this.SocketFileName;
          pdfFileUrl.innerHTML = "file uploaded successfully";
          let img = this.prevImg.nativeElement;
          img.setAttribute("src", "../../../assets/ppt-file-img.png");
        }
        this.barWidth = "0%";
        this.uploadInProgress = false;
      }
    });
  }

  ngAfterViewInit(): void {}
  swiperInstance: any;
  private initializeSwiper(): void {
    this.swiperInstance = new Swiper(this.swiperContainer?.nativeElement, {
      // Optional parameters
      slidesPerView: 2,
      spaceBetween: 10,
      autoWidth: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });
  }

  onChangeCompanyTag(tag) {
    this.companyNameTag = tag;
    this.companyRelatedTags = [];
    this.primaryTags = [
      this.collectionTypeTag,
      this.companyNameTag,
      this.isCompanyProjectTag,
      this.ndaTag,
    ];
    this.primaryTags = this.primaryTags.concat(this.companyRelatedTags);
  }
  selectedCollection = "";
  selectedTags = "Presentation";

  addCompanyRelatedTags(tag: any) {
    this.selectedTags = tag;
    if (tag == "image" || tag == "screenshot") {
      this.typeVideoTag = false;
      this.cameraButton.nativeElement.classList.remove("hide");
      this.screenCaptureButton.nativeElement.classList.remove("hide");
    } else if (tag == "video") {
      this.typeVideoTag = true;
      this.cameraButton.nativeElement.classList.remove("hide");
      this.screenCaptureButton.nativeElement.classList.remove("hide");
    } else {
      this.cameraButton.nativeElement.classList.add("hide");
      this.screenCaptureButton.nativeElement.classList.add("hide");
    }

    if (this.companyRelatedTags.indexOf(tag) != -1) {
      return;
    } else {
      this.companyRelatedTags.push(tag);
    }
    this.primaryTags = [
      this.collectionTypeTag,
      this.companyNameTag,
      this.isCompanyProjectTag,
      this.ndaTag,
    ];
    this.primaryTags = this.primaryTags.concat(this.companyRelatedTags);
  }

onChangeCollectionType(event: any) {
  this.selectedCollectionType = event.target.checked ? "Private" : "Public";

  this.collectionTypeTag = this.selectedCollectionType.toLowerCase();
  this.existcollecttion = this.selectedCollectionType === "Public";

  this.primaryTags = [
    this.collectionTypeTag,
    this.companyNameTag,
    this.isCompanyProjectTag,
    this.ndaTag,
    ...this.companyRelatedTags,
  ];
}


  onChangeCompanyProductType(event) {
    this.selectedProjectType = event.target.checked ? "Reference" : "Company";
    this.isCompanyProjectTag = this.selectedProjectType.toLocaleLowerCase();
    this.primaryTags = [
      this.collectionTypeTag,
      this.companyNameTag,
      this.isCompanyProjectTag,
      this.ndaTag,
    ];
    this.primaryTags = this.primaryTags.concat(this.companyRelatedTags);
  }

  onChangeNdaType(event) {
    this.selectedAgreementType = event.target.checked ? "Non-NDA" : "NDA";
    this.ndaTag = this.selectedAgreementType;
    this.primaryTags = [
      this.collectionTypeTag,
      this.companyNameTag,
      this.isCompanyProjectTag,
      this.ndaTag,
    ];
    this.primaryTags = this.primaryTags.concat(this.companyRelatedTags);
  }

projectForm = new FormGroup({
  title: new FormControl("", [
    Validators.required,
    Validators.maxLength(100), 
    Validators.pattern("^.{1,100}$") 
  ]),
  client_name: new FormControl("", [
    Validators.required,
    Validators.maxLength(100),
  ]),
  description: new FormControl("", [Validators.maxLength(1000)]),
});

  folderCheck: boolean = false;
  editData() {
    this.mediaService.getOneByMediaId(this.editId).subscribe(
      (res) => {
        console.log(res, "somethimnbjkh");

        this.pdfDisplay = "none";
        this.customTags = res["data"].tags || [];
        const mediaId = res["data"]._id;

        const tags: string[] = res["data"].tags || [];
        const lowerTags = tags.map((t: any) =>
          typeof t === "string" ? t.toLowerCase() : ""
        );

        if (lowerTags.includes("private")) {
          this.selectedCollectionType = "Private";
        } else {
          this.selectedCollectionType = "Public";
        }
        this.collectionTypeTag = this.selectedCollectionType.toLowerCase();

        if (lowerTags.includes("reference") || lowerTags.includes("ref")) {
          this.selectedProjectType = "Reference";
        } else {
          this.selectedProjectType = "Company";
        }
        this.isCompanyProjectTag = this.selectedProjectType.toLowerCase();

        if (
          lowerTags.includes("non-nda") ||
          lowerTags.includes("non nda") ||
          lowerTags.includes("non")
        ) {
          this.selectedAgreementType = "Non-NDA";
        } else {
          this.selectedAgreementType = "NDA";
        }
        this.ndaTag = this.selectedAgreementType;

        if (
          lowerTags.includes("ink in caps") ||
          lowerTags.includes("ink") ||
          lowerTags.includes("inkincaps")
        ) {
          this.companyNameTag = "ink in caps";
        } else {
          this.companyNameTag = "square pixel";
        }

        const categoryTag = tags.find((t: any) =>
          typeof t === "string" &&
          [
            "presentation",
            "excel",
            "image",
            "video",
            "pdf",
            "word/docs",
            "screenshot",
            "js",
            "git",
            "html",
            "angular",
          ].includes(t.toLowerCase())
        );
        if (categoryTag) {
          this.selectedTags = categoryTag;
        }

        this.primaryTags = [
          this.collectionTypeTag,
          this.companyNameTag,
          this.isCompanyProjectTag,
          this.ndaTag,
        ];

        const processedUrls = res["data"]["addtionalFiles"].map(
          ({ fileUrl, _id }) => {
            console.log({ fileUrl });
            if (!fileUrl.startsWith("https://")) {
              return "https://" + fileUrl;
            }
            return { fileUrl, _id, mediaId: mediaId };
          }
        );

        this.ImagefilesResponseUrl = processedUrls;
        console.log(res["data"]["highQuality"], "videoooooooooooooooooooooo");

        if (
          (res["data"]["highQuality"] && res["data"]["extension"] === ".mp4") ||
          res["data"]["extension"] === ".webm"
        ) {
          let video = document.getElementById("preview-video");
          video.setAttribute("src", res["data"]["highQuality"]);
          setTimeout(() => {
            video.setAttribute("src", res["data"]["highQuality"]);
          }, 5000);
          setTimeout(() => {
            video.setAttribute("src", res["data"]["highQuality"]);
          }, 10000);
          setTimeout(() => {
            video.setAttribute("src", res["data"]["highQuality"]);
          }, 20000);
          setTimeout(() => {
            video.setAttribute("src", res["data"]["highQuality"]);
          }, 30000);
          setTimeout(() => {
            video.setAttribute("src", res["data"]["highQuality"]);
          }, 40000);
          setTimeout(() => {
            video.setAttribute("src", res["data"]["highQuality"]);
          }, 50000);
          video.style.display = "block";
          video.style.objectFit = "contain";
        }
        if (res["data"]["ogFileUrl"]) {
          if ([".jpg", ".jpeg", ".png"].includes(res["data"]["extension"])) {
            let image = document.getElementById("preview-image");
            image.setAttribute("src", res["data"]["ogFileUrl"]);
            image.style.setProperty("max-width", "548px", "important");
          }
          if (
            res["data"]["extension"].includes(".xls") ||
            res["data"]["extension"].includes(".xlsx") ||
            res["data"]["extension"].includes(".csv")
          ) {
            let image = document.getElementById("preview-image");
            if (image) {
              image.setAttribute(
                "src",
                "../../../assets/Archive_files/excel-icon.png"
              );
            }
            // this.folderCheck = true;
          }
          if (res["data"]["extension"].includes(".pdf")) {
            let image = document.getElementById("preview-image");
            image.setAttribute("src", "../../../assets/Archive_files/pdf.png");
            image.style.setProperty("max-width", "548px", "important");
            // this.folderCheck = true;
          }
          if (res["data"]["extension"].includes(".pptx")) {
            let image = document.getElementById("preview-image");
            image.setAttribute(
              "src",
              "../../../assets/Archive_files/ppt-icon.png"
            );
            image.style.setProperty("max-width", "548px", "important");
            // this.folderCheck = true;
          }
          if (
            res["data"]["extension"].includes(".doc") ||
            res["data"]["extension"].includes(".docx")
          ) {
            let image = document.getElementById("preview-image");
            image.setAttribute("src", "../../../assets/docx-img.png");
            image.style.setProperty("max-width", "548px", "important");
            // this.folderCheck = true;
          }
        }
        const fileName =
          res["data"]["ogFileUrl"]?.split("/").pop() ||
          res["data"]["title"] ||
          "";
        const filenameEl = document.getElementById("upload-name");
        if (filenameEl) {
          filenameEl.innerHTML = fileName;
        }

        let fileUpload = document.getElementById("file-uploadCamera");
        if (fileUpload) {
          fileUpload.style.setProperty("display", "none", "important");
        }
        this.projectForm.patchValue({
          title: res["data"].title,
          client_name: res["data"].clientName,
          description: res["data"].description,
        });
      },
      (err) => {
        console.log(err);
      }
    );
  }

  goBack() {
    if (this.uploadInProgress || this.archiveInProgress) {
      alertModalWithoutConfirm("warning", "Upload in progress. Please wait until upload completes before navigating.");
      return;
    }
    this.router.navigate(["/collection"]);
  }

  slickInit(e) {
    console.log("slick initialized");
    this.archiveInProgress = false;
    console.log(this.archiveInProgress, "");
  }

  removePrimaryTag(idx) {
    this.primaryTags.splice(idx, 1);
  }

  removeCustomTag(idx) {
    this.customTags.splice(idx, 1);
  }

  onEnterKey(elementEvent) {
    if (elementEvent.key == "Enter") {
      var val = (<HTMLInputElement>document.getElementById("input-search"))
        .value;
      this.customTags.push(val);
      (<HTMLInputElement>document.getElementById("input-search")).value = "";
    }
  }

  changeFile: boolean = false;
  fileChange() {
    this.changeFile = true;
  }
  onClickScreenCapture() {
    var serv = this.mediaService;
    var mediaDevices = navigator.mediaDevices as any;
    if (this.typeVideoTag) {
      let audioTrack, videoTrack;

      mediaDevices
        .getDisplayMedia({ video: true })
        .then(async (displayStream) => {
          [videoTrack] = displayStream.getVideoTracks();
          const audioStream = await navigator.mediaDevices
            .getUserMedia({ audio: true })
            .catch((e) => {
              throw e;
            });
          [audioTrack] = audioStream.getAudioTracks();

          displayStream.addTrack(audioTrack);

          document.getElementsByClassName("file-upload")[0].remove();
          let start = document.getElementById("btnStart");
          let stop = document.getElementById("btnStop");
          let keep = document.getElementById("btnKeep");
          let controler = document.getElementById("recorder-control");
          let vidSave: any = document.getElementById("vid2");
          let mediaRecorder = new MediaRecorder(displayStream);
          let chunks = [];

          var video: any = document.querySelector("#preview-video");
          video.style.display = "inline";
          video.setAttribute("autoplay", "true");
          video.srcObject = displayStream;

          video.onloadedmetadata = (e) => {
            video.play();
            controler.style.left = "357px";
            video.muted = true;
            controler.classList.remove("hide");
          };

          start.addEventListener("click", (ev) => {
            vidSave.classList.add("hide");
            video.style.display = "initial";
            stop.classList.remove("hide");
            mediaRecorder.start();
            controler.style.left = "290px";

            console.log(mediaRecorder.state);
          });

          stop.addEventListener("click", (ev) => {
            mediaRecorder.stop();
            console.log(mediaRecorder.state);
            keep.classList.remove("hide");
          });
          mediaRecorder.ondataavailable = function (ev) {
            chunks.push(ev.data);
          };
          mediaRecorder.onstop = (ev) => {
            video.style.display = "none";
            vidSave.classList.remove("hide");
            controler.style.bottom = "32px";
            controler.style.left = "153px";
            let blob = new Blob(chunks, { type: "video/mp4" });
            chunks = [];
            let videoURL = URL.createObjectURL(blob);
            vidSave.setAttribute("src", URL.createObjectURL(blob) + ".mp4");
            const file = new File(chunks, "demo1.mp4", { type: "video/mp4" });
            this.blobFile = file;
            let tracks = video.srcObject.getTracks();
            tracks.forEach((track) => track.stop());
            video.srcObject = null;
          };
        })
        .catch(function (err) {
          alert("Screen capture not available");
        });
    } else {
      var video: any = document.getElementById("preview-video");
      var canvas: any = document.getElementById("pic-canvas");
      var photo = document.getElementById("pic-photo");
      var startbutton = document.getElementById("startbutton");
      var width = 1920;
      var height = video.videoHeight / (video.videoWidth / width);
      var upload = document.getElementsByClassName("file-upload")[0];
      var streaming = false;

      mediaDevices
        .getDisplayMedia({ video: true, audio: false })
        .then(function (stream) {
          video.style.display = "block";
          video.srcObject = stream;
          upload.classList.add("hide");

          startbutton.classList.remove("hide");
          video.play();

          video.addEventListener(
            "canplay",
            function (ev) {
              if (!streaming) {
                height = video.videoHeight / (video.videoWidth / width);

                let fileUpl = document.getElementById("file-uploadCamera");
                fileUpl.style.cssText = "display: none !important;";
                video.setAttribute("width", width);
                video.setAttribute("height", height);
                canvas.setAttribute("width", width);
                canvas.setAttribute("height", height);

                streaming = true;
              }
            },
            false
          );

          startbutton.addEventListener(
            "click",
            function (ev) {
              photo.classList.remove("hide");
              var context = canvas.getContext("2d");

              if (width && height) {
                canvas.width = width;
                canvas.height = height;
                context.drawImage(video, 0, 0, width, height);
                var data = canvas.toDataURL("image/png");

                canvas.toBlob(
                  (blob) => {
                    if (blob) {
                      console.log("Blob:", blob);
                      const file = new File([blob], "screenshot.jpeg", {
                        type: "image/jpeg",
                      });
                      // this.blogFile = file;
                      serv.createMedia(file).subscribe(
                        (resp) => {
                          console.log(resp, "image");
                          if (resp.type === HttpEventType.UploadProgress) {
                            const progress = Math.round(
                              (100 / (resp.total || 0)) * resp.loaded
                            );
                          } else if (resp.type === HttpEventType.Response) {
                            this.id = resp["body"]["data"]._id;

                            document.getElementById("ImageId").innerHTML =
                              this.id;

                            document
                              .getElementById("my-loader")
                              .classList.add("hide");
                          }

                          // serv.mediaID = resp["data"]._id;
                          console.log(resp, "photo");
                          document
                            .getElementById("my-loader")
                            .classList.add("hide");
                        },
                        (error) => {
                          console.error("Error uploading media:", error);
                          document
                            .getElementById("my-loader")
                            .classList.add("hide");
                        }
                      );
                    }
                  },
                  "image/jpeg",
                  0.9
                );
                photo.setAttribute("src", data);
              } else {
                var context = canvas.getContext("2d");
                context.fillStyle = "#AAA";
                context.fillRect(0, 0, canvas.width, canvas.height);

                var data = canvas.toDataURL("image/png");
                photo.setAttribute("src", data);
              }

              ev.preventDefault();
            },
            false
          );
        })
        .catch(function (err) {
          console.log("An error occurred: " + err);
        });
    }
    this.archiveInProgress = false;
  }

  canvasDisplayImage: boolean = true;
  imageDis: string = "inline";
  takePhoto() {
    document.getElementById("preview-video").style.display = "none";
    var image = document.getElementById("pic-photo");
    if (document.getElementById("pic-photo")) {
      image.style.width = "100%";
      image.style.height = "100%";
      image.style.objectFit = "cover";
    }
    this.uploadSelection = false;
    this.imageDis = this.imageDis === "inline" ? "none" : "inline";

    this.canvasDisplayImage = false;
  }
  pdfDisplay: string = "none";
  deleteUpload: boolean = false;
  pdfDis: string = "inline";
  togglePdfDisplay() {
    this.pdfDisplay = this.pdfDisplay === "none" ? "inline" : "none";
  }
  barWidth: string = "0%";
  imageStyle: string = "none";
  videoStyle: string = "none";
presignedData: any;

onClickUpload() {
  const input: any = document.getElementById("upload-input");

  if (!input) return;
  input.click();
}



showFilePlaceholder: boolean = false;
showLocalPreview(file: File) {
  const extension = '.' + file.name.split('.').pop()?.toLowerCase();
  const fileExtension = file.name.split('.').pop()?.toLowerCase() || '';
  
  this.imageUrl = null;
  this.videoUrl = null;
  this.pdfUrl = null;
  this.officeUrl = null;
  
  const filenameEl = document.getElementById("upload-name");
  if (filenameEl) filenameEl.innerHTML = file.name;

  if (['.jpg', '.jpeg', '.png', '.gif'].includes(extension)) {
    this.imageUrl = URL.createObjectURL(file);
  } else if (['.mp4', '.mov', '.webm', '.mkv'].includes(extension)) {
    this.videoUrl = URL.createObjectURL(file);
  } else if (['.pdf'].includes(extension)) {
    this.imageUrl = this.fileTypeImages['pdf'];
    this.showFilePlaceholder = true;
  } else if (['.doc', '.docx', '.ppt', '.pptx', '.xls', '.xlsx', '.csv'].includes(extension)) {
    this.imageUrl = this.fileTypeImages[fileExtension] || "../../../assets/excl-img.jpg";
    this.showFilePlaceholder = true;
  }
  
  this.previewVisible = true;
}



  onClickUploadEdit() {
    var serv = this.mediaService;
    const input: any = document.getElementById("upload-input");
    const video: any = document.getElementById("preview-video");
    const image: any = document.getElementById("preview-image");
    const pdf: HTMLElement | null = document.getElementById("preview-pdf");
    if (pdf) {
      pdf.style.display = "none";
    }
    input.click();
  }

  thumbnailSpinner: boolean = false;
  socketUploadFile: File;
  SocketFileName: any;
  additionalEditId: any;
  videoUrl: any = "";

  uploadSelection: boolean = true;
  onClickCamera() {
    var serv = this.mediaService;
    if (this.typeVideoTag) {
      navigator.mediaDevices
        .getUserMedia({ audio: true, video: true })
        .then((stream) => {
          document.getElementsByClassName("file-upload")[0].remove();
          let controler = document.getElementById("recorder-control");
          let start = document.getElementById("btnStart");
          let stop = document.getElementById("btnStop");
          let keep = document.getElementById("btnKeep");
          let vidSave: any = document.getElementById("vid2");
          let mediaRecorder = new MediaRecorder(stream);
          let chunks = [];

          var video: any = document.querySelector("#preview-video");
          video.style.display = "inline";
          video.setAttribute("autoplay", "true");
          video.srcObject = stream;
          video.onloadedmetadata = (e) => {
            video.play();
            controler.style.left = "339px";
            controler.classList.remove("hide");
          };

          start.addEventListener("click", (ev) => {
            mediaRecorder.start();
            stop.classList.remove("hide");
            controler.style.left = "257px";
            console.log(mediaRecorder.state);
          });
          stop.addEventListener("click", (ev) => {
            mediaRecorder.stop();
            controler.style.left = "153px";
            controler.style.bottom = "33px";
            document.getElementById("vid2").style.width = "300px";
            keep.classList.remove("hide");
            console.log(mediaRecorder.state);
          });
          mediaRecorder.ondataavailable = function (ev) {
            chunks.push(ev.data);
          };
          mediaRecorder.onstop = (ev) => {
            video.style.display = "none";
            vidSave.classList.remove("hide");
            let blob = new Blob(chunks, { type: "video/mp4;" });
            chunks = [];
            let videoURL = URL.createObjectURL(blob);
            const file = new File(chunks, "demo.mp4", { type: "video/mp4" });
            vidSave.setAttribute("src", URL.createObjectURL(blob));
            this.blobFile = file;
          };
        })
        .catch(function (err) {
          alert("Camera support not available");
        });
    } else {
      var mediaDevices = navigator.mediaDevices as any;
      var video: any = document.getElementById("preview-video");
      var canvas: any = document.getElementById("pic-canvas");
      var photo = document.getElementById("pic-photo");
      var startbutton = document.getElementById("startbutton");
      var width = 320;
      var height = video.videoHeight / (video.videoWidth / width);
      var upload = document.getElementsByClassName("file-upload")[0];
      var streaming = false;
      this.startPhoto = true;
      mediaDevices
        .getUserMedia({ video: true, audio: false })
        .then(function (stream) {
          video.style.display = "block";
          video.srcObject = stream;
          upload.classList.add("hide");

          startbutton.classList.remove("hide");
          video.play();

          video.addEventListener(
            "canplay",
            function (ev) {
              if (!streaming) {
                height = video.videoHeight / (video.videoWidth / width);

                video.setAttribute("width", width);
                video.setAttribute("height", height);
                video.style.objectFit = "cover";
                video.style.height = "90%";
                let take = document.getElementById("startbutton");
                take.style.marginTop = "3px";
                canvas.setAttribute("width", width);
                canvas.setAttribute("height", height);
                streaming = true;
              }
            },
            false
          );

          (startbutton as any).addEventListener(
            "click",
            function (ev: any): any {
              photo.classList.remove("hide");
              var context = canvas.getContext("2d");
              if (width && height) {
                canvas.width = width;
                canvas.height = height;
                context.drawImage(video, 0, 0, width, height);
                var data = canvas.toDataURL("image/png");
                var imageUrl = photo.getAttribute("src");
                canvas.toBlob(
                  (blob) => {
                    if (blob) {
                      const file = new File([blob], "screenshot.jpeg", {
                        type: "image/jpeg",
                      });

                      this.blogFile = file;
                      serv.createMedia(file).subscribe(
                        (resp) => {
                          if (resp.type === HttpEventType.UploadProgress) {
                            const progress = Math.round(
                              (100 / (resp.total || 0)) * resp.loaded
                            );
                            this.barWidth = progress + "%";
                            document.getElementById("prog").innerHTML =
                              this.barWidth;
                            document.getElementById("progressBar").style.width =
                              this.barWidth;
                            this.uploadInProgress = true;
                          } else if (resp.type === HttpEventType.Response) {
                            this.barWidth = "0%";
                            this.uploadInProgress = false;

                            this.id = resp["body"]["data"]._id;
                            document.getElementById("ImageId").innerHTML =
                              this.id;

                            document
                              .getElementById("my-loader")
                              .classList.add("hide");
                          }
                          video.style.display = "none";
                          document
                            .getElementById("my-loader")
                            .classList.add("hide");
                        },
                        (error) => {
                          console.error("Error uploading media:", error);
                          document
                            .getElementById("my-loader")
                            .classList.add("hide");
                        }
                      );
                    }
                  },
                  "image/jpeg",
                  0.9
                );

                photo.setAttribute("src", data);
              } else {
                var context = canvas.getContext("2d");
                context.fillStyle = "#AAA";
                context.fillRect(0, 0, canvas.width, canvas.height);
                var data = canvas.toDataURL("image/png");
                photo.setAttribute("src", data);
              }

              ev.preventDefault();
            },
            false
          );
        })
        .catch(function (err) {
          console.log("An error occurred: " + err);
        });
    }
  }

  capitalizeFirstLetter(inputString: string): string {
    if (!inputString || inputString.length === 0) {
      return inputString;
    }

    return inputString.charAt(0).toUpperCase() + inputString.slice(1);
  }

  additionalFilesData: any[] = [];
onClickCollection() {
  if (!this.selectedFile) {
    return alertModalWithoutConfirm("warning", "Please select a file first");
  }

  if (!this.projectForm.valid) {
    return alertModalWithoutConfirm(
      "warning",
      "Please fill in all required fields before uploading."
    );
  }

  this.mediaService.startBackgroundCollectionUpload({
    mediaId: this.mediaId,
    selectedFile: this.selectedFile,
    additionalFiles: this.additionalFiles,
    mainFileUrl: this.mainFileUrl,
    projectFormValue: this.projectForm.value,
    primaryTags: this.primaryTags,
    customTags: this.customTags,
    collectionTypeTag: this.collectionTypeTag,
    selectedTags: this.selectedTags,
    playList: this.playList,
    collectionTags: this.collectionTags,
    newCollection: this.newCollection,
    selectedTagId: this.selectedTagId,
    selectedImageUrl: this.selectedImageUrl,
  });

  this.router.navigate(["collection"]);
}




//optional for now
updatePreviewWithUploadedFile(file: File, fileUrl: string) {
  const extension = '.' + file.name.split('.').pop()?.toLowerCase();
  
  if (['.jpg', '.jpeg', '.png', '.gif'].includes(extension)) {
    this.imageUrl = fileUrl;
  } else if (['.mp4', '.mov', '.webm', '.mkv'].includes(extension)) {
    this.videoUrl = encodeURI(fileUrl);
  } else if (['.pdf'].includes(extension)) {
    this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(fileUrl);
  } else if (['.doc', '.docx', '.ppt', '.pptx', '.xls', '.xlsx', '.csv'].includes(extension)) {
    const encodedUrl = encodeURIComponent(fileUrl);
    this.officeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      "https://view.officeapps.live.com/op/embed.aspx?src=" + encodedUrl
    );
  }
}


async onClickCollectionEdit(publicType: boolean) {
  const id = this.editId;
  this.archiveInProgress = true;
  this.uploadInProgress = true;
  this.barWidth = "0%";

  try {
    let additionalFilesData: any[] = [];

    // 🔑 Grab only new files (added in edit mode)
    const newFiles = this.ImagefilesResponseUrl.filter(f => f.isNew && f.rawFile);

    if (newFiles.length) {
      // Prepare metadata for presigned URL API
      const filesMeta = newFiles.map((file: any) => {
        const { totalChunks } = this.getDynamicChunks(file.rawFile.size);
        return {
          fileName: file.fileName,
          totalChunks,
          fileSize: file.rawFile.size,
        };
      });

      const presignedResp: any = await this.mediaService
        .additionalGetPreSignedUrls(id, filesMeta)
        .toPromise();

      const presignedFiles = presignedResp?.data || [];
      console.log("PresignedFiles for edit:", presignedFiles);

      for (let i = 0; i < newFiles.length; i++) {
        const rawFile: File = newFiles[i].rawFile;
        const presignedFile = presignedFiles[i];
        if (!presignedFile) continue;

        const { urls, uploadId, uniqueFileName } = presignedFile;
        const { chunks } = this.getDynamicChunks(rawFile.size);

        let uploadedParts: any[] = [];

        for (let cIndex = 0; cIndex < urls.length; cIndex++) {
          const { partNumber, url } = urls[cIndex];
          const chunk = rawFile.slice(chunks[cIndex].start, chunks[cIndex].end);
          const res = await axios.put(url, chunk, {
            headers: { "Content-Type": "application/octet-stream" },
          });

          const eTag = res.headers["etag"]?.replace(/^"(.*)"$/, "$1");
          if (eTag) uploadedParts.push({ PartNumber: partNumber, ETag: eTag });

          await new Promise(resolve => setTimeout(resolve, 0));
        }

        additionalFilesData.push({
          uniqueFileName,
          uploadId,
          parts: uploadedParts,
        });
      }
    }

    // ✅ Complete additional uploads
    if (additionalFilesData.length > 0) {
      await this.mediaService
        .additionalCompleteUpload({ files: additionalFilesData })
        .toPromise();
    }

    // -------- Update metadata ----------
    const body: any = {
      title: this.projectForm.value["title"],
      clientName: this.projectForm.value["client_name"],
      description: this.projectForm.value["description"],
      tags: Array.from(new Set(this.primaryTags.concat(this.customTags))),
      isPublic: publicType,
      mediaId: id,
      ogFileUrl: this.mainFileUrl,
      fileType:
        this.selectedTags === "word/docs"
          ? "Word/Docs"
          : this.capitalizeFirstLetter(this.selectedTags),
      play_list: this.playList[0],
    };

    if (this.selectedFile) {
      body.extension = "." + this.selectedFile.name.split(".").pop()?.toLowerCase();
    }

    if (this.selectedTags.toLowerCase() === "video") {
      body.selected_thumbnail = this.selectedImageUrl;
    }

    if (this.collectionTags) {
      if (this.newCollection) {
        body.collectionData = {
          title: this.collectionTags,
          isPublic: this.collectionType === "Public",
        };
      } else {
        body.collectionId = this.selectedTagId;
      }
    }

    this.mediaService.updateMedia(body).subscribe(
      (resp) => {
        console.log("updated resp", resp);
        this.archiveInProgress = false;
        this.uploadInProgress = false;
        // reset new files
        this.ImagefilesResponseUrl = this.ImagefilesResponseUrl.filter(f => !f.isNew);
        alertModalWithoutConfirm("success", "Successfully Uploaded!");
        setTimeout(() => {
          this.router.navigate(["collection"]);
        }, 1000);
      },
      (err) => {
        console.log(err);
        this.archiveInProgress = false;
        this.uploadInProgress = false;
        const message = err.error.message || "Something went wrong!";
        alertModal("error", message);
      }
    );
  } catch (err) {
    console.error("Upload failed", err);
    this.archiveInProgress = false;
    this.uploadInProgress = false;
    alertModal("error", "Upload failed, please try again.");
  }
}





  keepRecording() {
    document.getElementById("my-loader").classList.remove("hide");
    this.mediaService.createMedia(this.blobFile).subscribe((resp) => {
      if (resp.type === HttpEventType.UploadProgress) {
        const progress = Math.round((100 / (resp.total || 0)) * resp.loaded);
        this.barWidth = progress + "%";
        document.getElementById("prog").innerHTML = this.barWidth;
        document.getElementById("progressBar").style.width = this.barWidth;
        this.uploadInProgress = true;

        console.log("uploadProgress", resp, this.barWidth);
      } else if (resp.type === HttpEventType.Response) {
        this.barWidth = "0%";
        this.uploadInProgress = false;

        this.id = resp["body"]["data"]._id;
        document.getElementById("ImageId").innerHTML = this.id;
        document.getElementById("my-loader").classList.add("hide");
      }
      document.getElementById("my-loader").classList.add("hide");
    });
  }

  keepData() {
    document.getElementById("my-loader").classList.remove("hide");
    this.mediaService.createMedia(this.blobFile).subscribe((resp) => {
      this.mediaService.mediaID = resp["data"]["_id"];
      document.getElementById("my-loader").classList.add("hide");
    });
  }

  images: File[] = [];
  loading: boolean = false;
  additionalFiles: File[] = [];
  additionalPreviewUrls: any[] = [];   
onClickAddImage(event: any) {
  if (!this.selectedFile || this.uploadInProgress) {
    alertModalWithoutConfirm(
      "warning",
      this.uploadInProgress
        ? "Please wait for the main file to finish uploading before adding additional files."
        : "Please upload the main file first before adding additional files."
    );
    return;
  }

  const files: File[] = Array.from(event.target.files);
  if (!files.length) return;

  const invalidFiles = files.filter(f => f.type.startsWith("audio/"));
  if (invalidFiles.length > 0) {
    alertModalWithoutConfirm(
      "warning",
      "Audio files are not allowed in additional uploads."
    );

    event.target.value = "";
    return;
  }

  this.additionalFiles = [...this.additionalFiles, ...files];
  this.showAdditionalPreview(files);

  console.log("All selected additional files:", this.additionalFiles);
}



showAdditionalPreview(files: File[]) {
  if (!this.ImagefilesResponseUrl) {
    this.ImagefilesResponseUrl = [];
  }

  files.forEach((file, index) => {
    const extension = file.name.split('.').pop()?.toLowerCase() || '';
    let fileUrl = URL.createObjectURL(file);
    let type: 'image' | 'video' | 'document' = 'document';

    if (['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(extension)) {
      type = 'image';
    } else if (['mp4', 'mov', 'webm', 'mkv'].includes(extension)) {
      type = 'video';
    } else if (['pdf'].includes(extension)) {
      type = 'document';
      fileUrl = this.fileTypeImages['pdf'];
    } else if (['doc', 'docx', 'ppt', 'pptx', 'xls', 'xlsx', 'csv'].includes(extension)) {
      type = 'document';
      fileUrl = this.fileTypeImages[extension] || '../../../assets/excl-img.jpg';
    }

    this.ImagefilesResponseUrl.push({
      _id: 'temp-' + Date.now() + '-' + index + '-' + file.name,
      fileUrl,
      fileName: file.name,
      type,
    });
  });
}




onClickAddImageEdit(event: any) {
  const newFiles: File[] = Array.from(event.target.files);
  if (!newFiles.length) return;

  newFiles.forEach((file) => {
    const extension = "." + file.name.split(".").pop()?.toLowerCase();
    let fileUrl = "";

    if ([".jpg", ".jpeg", ".png", ".gif"].includes(extension)) {
      fileUrl = URL.createObjectURL(file);
    } else if ([".mp4", ".mov", ".webm", ".mkv"].includes(extension)) {
      fileUrl = URL.createObjectURL(file);
    } else {
      fileUrl =
        this.fileTypeImages[extension.replace(".", "")] ||
        "../../../assets/document-placeholder.png";
    }

    this.ImagefilesResponseUrl.push({
      _id: "temp-" + file.name,  
      fileUrl,
      fileName: file.name,
      type: file.type.startsWith("image")
        ? "image"
        : file.type.startsWith("video")
        ? "video"
        : "doc",
      isNew: true,         // mark as new
      rawFile: file        // 🔑 keep actual File object for upload
    });
  });

  console.log("Updated ImagefilesResponseUrl (edit):", this.ImagefilesResponseUrl);
}






onClickDeleteImage(idx: string) {
  console.log("Deleting additional preview:", idx);

  this.ImagefilesResponseUrl = this.ImagefilesResponseUrl.filter(
    (item) => item._id !== idx && item.fileName !== idx
  );

  this.additionalFiles = this.additionalFiles.filter(
    (file) => file.name !== idx
  );

  console.log("Updated additional previews:", this.ImagefilesResponseUrl);
}



onClickDeleteImaEdited(idx: string, mediaId?: string) {
  console.log("Deleting file:", idx);

  const fileToDelete = this.ImagefilesResponseUrl.find((item) => item._id === idx);

  if (fileToDelete?.isNew) {
    this.ImagefilesResponseUrl = this.ImagefilesResponseUrl.filter(
      (item) => item._id !== idx
    );
  } else {
    this.mediaService.deleteImage(mediaId, idx.toString()).subscribe((resp) => {
      if (resp && resp["statusCode"] === 200) {
        this.ImagefilesResponseUrl = this.ImagefilesResponseUrl.filter(
          (item) => item._id !== idx
        );
      }
    });
  }
}


  cleanUrl(url: any): string {
    if (!url) return "";
    let strUrl = typeof url === "string" ? url : (url.fileUrl || "");
    return strUrl.split('?')[0].toLowerCase();
  }

  getFileExtension(url: any): string {
    const cleaned = this.cleanUrl(url);
    if (!cleaned) return "";
    return cleaned.split('.').pop() || "";
  }

  isImage(url: any): boolean {
    const ext = this.getFileExtension(url);
    return ['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg', 'bmp'].includes(ext);
  }

  fileTypeImages: { [key: string]: string } = {
    doc: "../../../assets/docx-img.png",
    docx: "../../../assets/docx-img.png",
    xls: "../../../assets/excl-img.jpg",
    xlsx: "../../../assets/excl-img.jpg",
    csv: "../../../assets/excl-img.jpg",
    pdf: "../../../assets/Archive_files/pdf.png",
    ppt: "../../../assets/ppt-file-img.png",
    pptx: "../../../assets/ppt-file-img.png",
  };

  getFileTypeImage(url: any): string {
    const ext = this.getFileExtension(url);
    return this.fileTypeImages[ext] || "../../../assets/excl-img.jpg";
  }

  isDocument(url: any): boolean {
    const ext = this.getFileExtension(url);
    return ['doc', 'docx', 'xls', 'xlsx', 'csv', 'pdf', 'ppt', 'pptx', 'txt'].includes(ext);
  }

  getFileTypeIcon(url: string): string {
    return this.getFileTypeImage(url);
  }

  isVideo(url: any): boolean {
    const ext = this.getFileExtension(url);
    return ['mp4', 'avi', 'webm', 'mov', 'mkv'].includes(ext);
  }

  openWindow(data: any) {
    window.open(this.data);
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
  }

deleteMedia(idx?: string) {
  if (!this.mediaId) {
    if (this.selectedFile) {
      this.selectedFile = null;
      this.imageUrl = null;
      this.videoUrl = null;
      this.pdfUrl = null;
      this.officeUrl = null;
      this.previewVisible = false;
      this.showFilePlaceholder = false;

      // clear filename
      const filenameEl = document.getElementById("upload-name");
      if (filenameEl) filenameEl.innerHTML = "";

      alertModalWithoutConfirm("success", "File removed successfully");
    }
    return;
  }

  const mediaId = idx || this.mediaId;

  alertModalDelete("You won't be able to revert this!").then((isConfirmed) => {
    if (isConfirmed) {
      this.mediaService.deleteOnyById(mediaId).subscribe(
        (res) => {
          console.log("Deleted:", res);

          this.selectedFile = null;
          this.imageUrl = null;
          this.videoUrl = null;
          this.pdfUrl = null;
          this.officeUrl = null;
          this.previewVisible = false;
          this.showFilePlaceholder = false;
          this.mediaId = null;
          this.id = null;
          this.mainFileUrl = "";
          this.ResponseData = null;
          this.filesUrl = [];
          this.showThumbnail = false;
          this.thumbnailSpinner = false;
          
          this.mediaService.removeTempUpload(mediaId);

          // clear file input and filename
          const input: any = document.getElementById("upload-input");
          if (input) input.value = "";

          const filenameEl = document.getElementById("upload-name");
          if (filenameEl) filenameEl.innerHTML = "";
        },
        (error) => {
          console.error(error);
          const message = error.error.message || "Something went wrong!";
          alertModal("error", message);
        }
      );
    }
  });
}






  breakpoint(e: any) {
    console.log("breakpoint");
  }

  isLastSlide: boolean = false;
  afterChange(e: any) {}

  beforeChange(e: any) {
    console.log("beforeChange");
  }

  downloadImagesAll: any;

  async downloadFileAll(): Promise<File[]> {
    const downloadPromises = this.ResponseData["data"]["files_url"].map(
      async (fileUrl) => {
        const response = await fetch(fileUrl);
        const blob = await response.blob();
        const filename = fileUrl.split("/").pop();
        return new File([blob], filename, { type: blob.type });
      }
    );
    return Promise.all(downloadPromises);
  }

  async downloadZip() {
    const filesArray = await this.downloadFileAll();
    const zip = new JSZip();
    const imageFolder = zip.folder("images");
    filesArray.forEach((file) => {
      imageFolder.file(file.name, file);
    });
    zip.generateAsync({ type: "blob" }).then((content) => {
      saveAs(content, "images.zip");
    });
  }

  selectedImageUrl: string = "";
  selectedImageIndex: number = -1;

  onClickImage(imageUrl: string, index: number) {
    this.selectedImageUrl = imageUrl;
    this.selectedImageIndex = index;

    console.log(this.selectedImageUrl, "imageurl");
    if (this.slickModal) {
      this.slickModal.slickGoTo(index);
    }
  }

  clientNameControl = new FormControl();
  recentClientNames = ["Client A", "Client B", "Client C", "Client D"];
  filteredSuggestions: string[] = [];
  showSuggestions = false;

  toggleSuggestions(): void {
    this.showSuggestions = !this.showSuggestions;
  }

  onInput(inputValue: string): void {
    this.filteredSuggestions = this.recentClientNames.filter((name) =>
      name.toLowerCase().startsWith(inputValue.toLowerCase())
    );
  }
  selectSuggestion(suggestion: string): void {
    this.clientNameControl.setValue(suggestion);
    this.showSuggestions = false;
  }
  textInput: string = "";
  selectedImage: File | null = null;

  onSubmit() {}

  onImageSelect(event: any) {
    const files = event.target.files;
    if (files && files.length > 0) {
      this.selectedImage = files[0];
    }
  }
  // selectedCollectionType: "Public" | "Private" = "Public";
collectionTitle: string = "";
createCollection() {
  var collectionTag = document.querySelector(
    ".collection-input"
  ) as HTMLInputElement;
  this.collectionTags = collectionTag.value;
  this.newCollection = true;

  if (this.collectionTags && this.collectionType) {
    this.playList.push({
      name: this.collectionTags,
      type: this.collectionType,
    });
    collectionTag.value = "";
  }

  console.log("Created collection:", this.playList);
}



  addCollectionType(string: any) {
    this.collectionType = string;
    console.log(this.collectionType);
  }
  AllPlayList: any;
  PlayListNames: any = [];
  //GET ALL PLAYLIST
  // getAllPlaylist() {
  //   this.mediaService.playLists().subscribe(
  //     (res) => {
  //       this.AllPlayList = res["data"];
  //       this.AllPlayList.map((list) => {
  //         list.play_list.forEach((list) => {
  //           const name = list.name;
  //           const type = list.type;
  //           this.PlayListNames.push({
  //             name: name,
  //             type: type,
  //           });
  //         });
  //       });
  //     },
  //     (err) => {
  //       console.log(err);
  //     }
  //   );
  // }
  selectedTagId: any;
  selectedPlayList(index: any) {
    console.log(index, "selected");
    this.collectionTags = index.title;
    this.selectedTagId = index._id;
    this.newCollection = false;
    this.playList[index];
    console.log(this.playUsersList[index], "SELECT ");
    this.collectionType = this.playUsersList[index].type;
    this.collectionTags = this.playUsersList[index].name;
    this.selectedCollection = this.collectionTags;
    console.log(
      { collectionTags: this.collectionTags },
      "kkkkkkkkkkkkkkkkkkkkkk"
    );
    // this.createCollection();
  }

  removeSelected(title: string): void {
    this.collectionTags = "";
    this.selectedTagId = "";
  }

  // removeSelected(nameToRemove: any) {
  //   const indexToRemove = this.playList.findIndex(
  //     (item) => item.name === nameToRemove
  //   );
  //   console.log(nameToRemove, "remove playlist", this.playList);
  //   if (indexToRemove !== -1) {
  //     this.playList.splice(indexToRemove, 1);
  //     this.collectionTags = "";
  //     this.selectedCollection = "Add To Collection";
  //     this.existingCollections = "";
  //     this.selectedTagId = "";
  //     console.log(`Removed playlist with name: ${nameToRemove}`);
  //   } else {
  //     console.log(`Playlist with name ${nameToRemove} not found.`);
  //   }
  //   console.log(nameToRemove, "remove playlist", this.playList);
  // }

  playUsersList: any;

  getInvitation() {
    let id = localStorage.getItem("guestID");

    this.UserService.getOneUser(id).subscribe(
      (res) => {
        let data = res["data"];
        this.AllPlayList = data.user.play_list;
        this.playUsersList = data.user.play_list;
        // this.AllPlayList.map((item) => {
        //   item.forEach((data) => {
        //     console.log(data, "res =>");
        //   });
        // });
        const nameAndTypeArray = this.AllPlayList.map((item) => {
          return {
            name: item.play_list[0].name,
            type: item.play_list[0].type,
          };
        });

        const uniqueMap = {};
        const uniqueArray = [];

        for (const obj of nameAndTypeArray) {
          if (!uniqueMap[obj.name]) {
            uniqueMap[obj.name] = true;
            uniqueArray.push(obj);
          }
        }

        this.playUsersList = uniqueArray;
      },
      (err) => {
        console.log(err);
      }
    );
  }

  onFileSelected(event) {
    this.selectedFile = event.target.files[0];
  }
  bytesToMB(bytes: number): number {
    return bytes / (1024 * 1024);
  }

  async onFileDrop(event: DragEvent) {
    event.preventDefault();
    const files = event.dataTransfer?.files;
    if (files && files.length > 0) {
      const file = files[0];
      await this.processDroppedFile(file);
    }
  }

  async processDroppedFile(file: File) {
    if (!file) return;

    if (file.type.startsWith("audio/")) {
      alertModalWithoutConfirm(
        "warning",
        "Audio files are not allowed. Please upload a valid file."
      );
      return;
    }

    const extension = "." + file.name.split(".").pop()?.toLowerCase();
    let detectedType = this.getFileType(file.type);
    if (
      !detectedType &&
      (extension === ".csv" || extension === ".xls" || extension === ".xlsx")
    ) {
      detectedType = "Excel";
    }
    this.selectedTags = detectedType ? detectedType : "Other";

    this.selectedFile = file;
    this.showLocalPreview(file);

    await this.uploadMediaFile(file);
  }

  getFileType(fileType: string): string | undefined {
    switch (fileType) {
      case "image/png":
      case "image/jpeg":
      case "image/jpg":
        return "Image";
      case "video/mp4":
      case "video/quicktime":
      case "video/webm":
      case "video/x-matroska":
        return "Video";
      case "application/pdf":
        return "pdf";
      case "application/vnd.openxmlformats-officedocument.presentationml.presentation":
        return "Presentation";
      case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
      case "application/msword":
        return "Word/Doc";
      case "text/csv":
      case "application/csv":
      case "text/x-csv":
      case "text/comma-separated-values":
      case "application/vnd.ms-excel":
      case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
        return "Excel";
      default:
        return undefined;
    }
  }

  fileToBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const base64String = reader.result as string;
        const base64WithoutPrefix = base64String.split(",")[1];
        resolve(base64WithoutPrefix);
      };
      reader.onerror = (error) => {
        reject(error);
      };
      reader.readAsDataURL(file);
    });
  }

async uploadMedia(ev: any) {
  const file: File = ev.target.files[0];
  if (!file) return;

  if (file.type.startsWith("audio/")) {
    alertModalWithoutConfirm(
      "warning",
      "Audio files are not allowed. Please upload a valid file."
    );
    ev.target.value = ""; 
    return;
  }

  const extension = "." + file.name.split(".").pop()?.toLowerCase();
  let detectedType = this.getFileType(file.type);
  if (!detectedType && (extension === ".csv" || extension === ".xls" || extension === ".xlsx")) {
    detectedType = "Excel";
  }
  this.selectedTags = detectedType ? detectedType : "Other";

  this.selectedFile = file;
  this.showLocalPreview(file);

  await this.uploadMediaFile(file);
}

async uploadMediaFile(file: File) {
  this.socketUploadFile = file;
  this.uploadInProgress = true;

  try {
    const { chunks, totalChunks } = this.getDynamicChunks(file.size);

    const presignedResp: any = await this.mediaService
      .getPreSignedUrls(file.name, totalChunks, file.size)
      .toPromise();

    const { uploadId, urls, mediaId, fileUrl } = presignedResp.data; 
    this.mediaId = mediaId;
    this.mainFileUrl = fileUrl;
    let uploadedParts: any[] = [];
    let chunkProgress: { [key: number]: number } = {};
    this.archiveInProgress = false;
    
    const tempCard = {
      _id: mediaId,
      title: this.projectForm.value["title"] || file.name,
      clientName: this.projectForm.value["client_name"] || "",
      description: this.projectForm.value["description"] || "",
      tags: this.primaryTags.concat(this.customTags),
      isPublic: this.collectionTypeTag === "public",
      extension: "." + file.name.split(".").pop()?.toLowerCase(),
      ogFileUrl: fileUrl,
      isUploading: true,
      progress: 0,
      uploadedBy: localStorage.getItem("username"),
      profileImg: localStorage.getItem("profileImg"),
      createdAt: new Date(),
      userId: localStorage.getItem("guestID"),
    };
    this.mediaService.addTempUpload(tempCard);

    // Upload chunks
    for (let i = 0; i < urls.length; i++) {
      const { partNumber, url } = urls[i];
      const chunk = file.slice(chunks[i].start, chunks[i].end);
      const res = await axios.put(url, chunk, {
        headers: { "Content-Type": "application/octet-stream" },
        onUploadProgress: (pe) => {
          if (pe.loaded && pe.total) {
            chunkProgress[partNumber] = pe.loaded;
            const totalUploaded = Object.values(chunkProgress).reduce((a, b) => a + b, 0);
            const progress = Math.floor((totalUploaded / file.size) * 100);

            this.progress = progress;
            this.barWidth = progress + "%";
            const progEl = document.getElementById("prog");
            if (progEl) progEl.innerHTML = this.barWidth;
            const progressBarEl = document.getElementById("progressBar");
            if (progressBarEl) progressBarEl.style.width = this.barWidth;
            
            this.mediaService.updateTempProgress(mediaId, progress);
          }
        },
      });

      const eTag = res.headers["etag"]?.replace(/^"(.*)"$/, "$1");
      if (eTag) uploadedParts.push({ PartNumber: partNumber, ETag: eTag });

      await new Promise(resolve => setTimeout(resolve, 0));
    }

    // Complete upload
    await this.mediaService.completeUpload(mediaId, uploadId, uploadedParts).toPromise();

    this.archiveInProgress = false;
    this.barWidth = "100%";
    this.progress = 100;

    this.mediaId = mediaId;
    this.id = mediaId;
    this.mediaService.updateTempProgress(mediaId, 100);

    // normalized response
    const normalizedResp = {
      _id: mediaId,
      extension: "." + file.name.split(".").pop()?.toLowerCase(),
      fileUrl: fileUrl, 
      thumbnail: "",
    };

    // Call preview handler
    this.handlePreview(file, { data: normalizedResp });

    setTimeout(() => (this.barWidth = "0%"), 1500);
  } catch (err) {
    console.error("Upload failed", err);
    this.messageError = "Upload failed, please try again.";
    this.archiveInProgress = false;
  } finally {
    this.uploadInProgress = false;
  }
}


previewVisible = false;
imageUrl: string | null = null;
officeUrl: any = null;

private handlePreview(file: File, resp: any) {
  const extension = resp.data.extension?.toLowerCase();
  const fileUrl = resp.data.fileUrl; 

  this.previewVisible = true;
  this.archiveInProgress = false;

  this.mediaId = resp.data._id;
  this.id = resp.data._id;
  this.mainFileUrl = fileUrl;

  const filenameEl = document.getElementById("upload-name");
  if (filenameEl) filenameEl.innerHTML = file.name;

  if (this.imageUrl || this.videoUrl || this.pdfUrl || this.officeUrl) {
    return;
  }

  this.imageUrl = null;
  this.videoUrl = null;
  this.pdfUrl = null;
  this.officeUrl = null;

  if ([".jpg", ".jpeg", ".png", ".gif"].includes(extension)) {
    this.imageUrl = URL.createObjectURL(file);
  } else if ([".mp4", ".mov", ".webm", ".mkv"].includes(extension)) {
    this.videoUrl = encodeURI(fileUrl);
    console.log(this.videoUrl, "videoUrl");
  } else if ([".pdf"].includes(extension)) {
    fetch(fileUrl)
      .then(res => res.blob())
      .then(blob => {
        this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(blob));
      });
  } else if ([".csv"].includes(extension)) {
    this.imageUrl = this.fileTypeImages["csv"] || "../../../assets/excl-img.jpg";
    this.showFilePlaceholder = true;
  } else if (
    [".doc", ".docx", ".ppt", ".pptx", ".xls", ".xlsx"].includes(extension)
  ) {
    const encodedUrl = encodeURIComponent(fileUrl);
    this.officeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      "https://view.officeapps.live.com/op/embed.aspx?src=" + encodedUrl
    );
  }
}













  existingCollections: any;
  addToExistingCollection() {
    this.mediaService.getCollectionGroup().subscribe((res) => {
      this.existingCollections = res["data"];
    });
  }


    private getDynamicChunks(fileSize: number) {
    let chunks = [];
    let totalChunks = Math.ceil(fileSize / CHUNK_SIZE);

    for (let i = 0; i < totalChunks; i++) {
      let start = i * CHUNK_SIZE;
      let end = Math.min(start + CHUNK_SIZE, fileSize);

      if (
        i === totalChunks - 1 &&
        end - start < MIN_CHUNK_SIZE &&
        chunks.length > 0
      ) {
        let previousChunk = chunks.pop();
        start = previousChunk.start;
        end = fileSize;
        totalChunks--;
      }

      chunks.push({ start, end });
    }

    return { chunks, totalChunks };
  }

}
